import { DOCUMENT } from '@angular/common';
import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  private readonly document = inject(DOCUMENT);
  private readonly rendererFactory = inject(RendererFactory2);
  private readonly renderer: Renderer2;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  set(favicon: string) {
    const newLink = this.renderer.createElement('link');
    this.renderer.setAttribute(newLink, 'rel', 'icon');
    this.renderer.setAttribute(newLink, 'type', 'image/x-icon');
    // Cache buster per sicurezza
    this.renderer.setAttribute(newLink, 'href', `${favicon}`);

    this.renderer.appendChild(this.document.head, newLink);
  }
}
